import { Map } from "ol";
import BaseLayer from "ol/layer/Base";
import LayerGroup from "ol/layer/Group";
import { LayerTitle } from "../types/layers";

export function findLayerByTitle(
  map: Map | undefined,
  title: LayerTitle,
): BaseLayer | null {
  let returnLayer: BaseLayer | null = null;
  map?.getLayers().forEach((l) => {
    if (l instanceof LayerGroup) {
      l.getLayers().forEach((lay) => {
        if (lay.get("title") === title) {
          returnLayer = lay;
        }
      });
    } else if (l instanceof BaseLayer) {
      if (l.get("title") === title) {
        returnLayer = l;
      }
    }
  });
  return returnLayer;
}
